// extracted by mini-css-extract-plugin
export default {"approveBtn":"Leadership_approveBtn__-jDcT","rejectBtn":"Leadership_rejectBtn__yPXos"};